module.exports = new __parcel__URL__("mount.04e47eca.png").toString();